import React from 'react'
import Title from '../components/Title/Title'
import Crash from '../components/Crash/Crash'

const CrashPage = () => {
	return (
		<main className='main'>
			<div className='container'>
				<Title>Crash</Title>
				<Crash />
			</div>
		</main>
	)
}

export default CrashPage
